import Card from '@components/card';

const UnderConstructionNotice = ({ role }) => {
  return (
    <section className='display-flex flex-justify-center margin-top-6 margin-bottom-4'>
      <Card className='maxw-tablet width-full padding-3 text-center border border-base-lighter radius-md bg-base-lightest'>
        <h2 className='margin-top-0 margin-bottom-2'>{role} Dashboard</h2>
        <p className='margin-0 text-base'>This dashboard is currently under construction. Please check back soon.</p>
      </Card>
    </section>
  );
};

export default UnderConstructionNotice;
